import { PublicLayout } from '../../layout/PublicLayout';
import { createRoute } from '..';
import { layoutRouteId } from '../definePath';
import { Route as rootRoute } from './__root';
import { type AuthenticatedGuard, composePublicBeforeLoad } from './_authenticated.guard';

const PUBLIC_LAYOUT_ID = layoutRouteId('public');

export function createPublicRoute(extraGuards: readonly AuthenticatedGuard[]) {
  return createRoute({
    id: PUBLIC_LAYOUT_ID,
    getParentRoute: () => rootRoute,
    beforeLoad: composePublicBeforeLoad(extraGuards),
    // Prevent the layout shell from unmounting during child route suspense;
    // only the child route should show a pending skeleton, not the entire page.
    wrapInSuspense: false,
    component: PublicLayout,
  });
}
